import { ReserveType } from '@utils/itinerary';

export interface BlurryImage {
    src: string;
    blurHash: string;
}

export interface SiteImage {
    src: string;
    alt: string;
}

export interface ContentImage {
    src: string;
    blurHash: string;
    alt?: string;
    width?: number;
    height?: number;
}

export const ParentReserveTypes = {
    flights: ReserveType.Flight,
    buses: ReserveType.Bus,
    trains: ReserveType.Train,
    train_ticket: ReserveType.Train,
    hotel: ReserveType.Hotel,
    car_rental: ReserveType.Taxi,
    taxi: ReserveType.Taxi,
    ship_ticket: undefined,
    _: undefined,
};
